import { getRequest } from "./api";

export const initMenu = (router, store) => {
  if (store.state.routes.length > 0) {
    return;
  }
  getRequest("/api/system/config/menu").then((data) => {
    if (data) {
      let fmtRoutes = formatRoutes(data);
      router.addRoutes(fmtRoutes);
      store.commit("initRoutes", fmtRoutes);
      store.dispatch("connect");
    }
  });
};
export const formatRoutes = (routes) => {
  let fmRoutes = [];
  routes.forEach((router) => {
    let { path, component, name, meta, iconCls, children } = router;
    if (children && children instanceof Array) {
      children = formatRoutes(children);
    }
    let hidden = router.hidden;
    // if(component.startsWith('AppUserDetail') || component.startsWith('OrderView')){
    //    return ;
    // }
    let fmRouter = {
      path: path,
      name: name,
      iconCls: iconCls,
      meta: meta,
      hidden:hidden,
      children: children,
      component(resolve) {
        if (component.startsWith("Home")) {
          require(["../views/" + component + ".vue"], resolve);
        } else if (component.startsWith("Charge")) {
          require(["../views/charge/" + component + ".vue"], resolve);
        } else if (component.startsWith("Per")) {
          require(["../views/per/" + component + ".vue"], resolve);
        }else if (component.startsWith("CardConsumeList")) {
          require(["../views/per/" + component + ".vue"], resolve);
        }  else if (component.startsWith("Sys")) {
          require(["../views/sys/" + component + ".vue"], resolve);
        } else if (component.startsWith("Order")) {
          require(["../views/order/" + component + ".vue"], resolve);
        } else if (component.startsWith("Feed")) {
          require(["../views/feedback/" + component + ".vue"], resolve);
        } else if (component.startsWith("App")) {
          require(["../views/appuser/" + component + ".vue"], resolve);
        }
        else if(component.startsWith('U1')){
          require(["../views/appuser/AppUserDetail.vue"], resolve);
        } else if(component.startsWith('U2')){
          require(["../views/order/OrderView.vue"], resolve);
        } 
        else {
          require(["../views" + path  + ".vue"], resolve);
        }
      },
    };
    fmRoutes.push(fmRouter);
  });

  return fmRoutes;
};
